import { Spanish } from 'flatpickr/dist/l10n/es';
import { French } from 'flatpickr/dist/l10n/fr';
import { Catalan } from 'flatpickr/dist/l10n/cat';
export const getFlatpickrLocale = locale => {
  switch (locale) {
    case 'es':
      return Spanish;
    case 'fr':
      return French;
    case 'ca':
      return Catalan;
    default:
      return 'en';
  }
};